<template>
    <div class="btn green-gradient" @click="clicked">
        <p>{{ buttonLabel.toUpperCase() }}</p>
        <i class="fas fa-qrcode"></i>
    </div>
</template>

<script>
export default {
  data () {
    return {
      buttonImage: 'qr-code.png',
      buttonLabel: 'Scan another order'
    }
  },
  methods: {
    clicked () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    position: absolute;
    left: 0 ; right: 0; bottom: 0;
    z-index: 100;
    display: flex;
    -webkit-display: flex;
    width: 90%;
    max-width: 400px;
    height: 50px;
    border: none;
    border-radius: 30px;
    -webkit-border-radius: 30px;
    letter-spacing: .5px;
    font-size: 16px;
    color: white;
    font-weight: 700;
    margin: 10px auto;
    box-shadow: 0px 5px 5px 1px darkgray;

    i {
      font-size: 30px;
      position: absolute;
      top: 50%;
      left: 10%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
    }

    p {
      display: flex;
      justify-content: center;
      align-items: center;
      -webkit-display: flex;
      -webkit-justify-content: center;
      -webkit-align-items: center;
      margin: 0px;
      width: 100%;
    }
  }

  @media screen and (max-width: 320px) {
    .btn {
      height: 40px;
      font-size: 14px;

      i {
        font-size: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/buttons/ScanAnotherCode.vue